import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SingleState from '../states/single.state';

interface ConstData {
    [key: string]: any;
}

const initialState: SingleState = {
    data: {},
    loading: false,
    error: null,
};

const constSlice = createSlice({
    name: 'const',
    initialState,
    reducers: {
        setConstData: (state, action: PayloadAction<ConstData>) => {
            return {
                ...state,
                data: action.payload
            };
        },
        resetConstData: (state) => {
            return {
                ...state,
                data: {}
            };
        },
    },
});

export const { setConstData,resetConstData } = constSlice.actions;
export default constSlice.reducer;
